import { ClientGateway } from "@kex/api";

export const constants = {
  default: () => ["exchange-pairs"] as const,
  detail: (id: string) => [...constants.default(), "detail", id] as const,
  get: (params: ClientGateway.ExchangePairsApiGetApiV1ExchangePairsRequest) =>
    [...constants.default(), JSON.stringify(params)] as const,
};
